import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, delay, map, mergeMap, switchMap } from 'rxjs/operators';
import { ErrorService } from 'src/app/services/error.service';
import { ExportDataService } from 'src/app/services/export-data.service';
import { QueryParamsModel } from 'src/app/utils/query-params.model';
import { environment } from 'src/environments/environment';
import * as AuditPropsSearchActions from '../actions/audit-prop-search.actions';
import { AppState } from '../app.reducer';

@Injectable()
export class AuditPropsSearchEffects {
  constructor(
    public actions$: Actions,
    public http: HttpClient,
    private store: Store<AppState>,

    private errorService: ErrorService,
    private exportDataService: ExportDataService
  ) { }
  payloadReload;


  getCatalog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuditPropsSearchActions.auditPropsSearchGet),
      switchMap((payload) => {
        const query = { ...payload.payload, filters: JSON.stringify(payload.payload.filters) };
        const kadik = payload.kadik;
        this.store.dispatch(AuditPropsSearchActions.auditPropsSearchLoading({ payload: { loading: true } }));
        this.payloadReload = payload.payload;
        const queryPayload = {
          filters: query.filters,
          sortOrder: query.sortOrder,
          sortField: query.sortField,
          pageNumber: query.pageNumber.toString(),
          pageSize: query.pageSize.toString(),
        };
        return this.http
          .get<{ data: any[]; query: QueryParamsModel; totalCount: number }>(
            environment.apiUrl + '/audit/props/' + kadik + '?' + queryPayload,
            {
              params: queryPayload,
            }
          )
          .pipe(
            switchMap((responseData) => {
              this.store.dispatch(
                AuditPropsSearchActions.auditPropsSearchSuccess({
                  payload: {
                    catalog: responseData.data,
                    totalCount: +responseData.totalCount,
                  },
                })
              );
              return of(AuditPropsSearchActions.auditPropsSearchLoading({ payload: { loading: false } }));
            }),
            catchError((error) => {
              this.store.dispatch(
                AuditPropsSearchActions.auditPropsSearchFail({ payload: { error: this.errorService.mapError(error) } })
              );
              return of(AuditPropsSearchActions.auditPropsSearchLoading({ payload: { loading: false } }));
            })
          );
      })
    )
  );
};
